import React from "react";
// import DetailCart from "../../components/carts/DetailCart";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";

const Client = () => {
  return (
    <div className="relative py-20 md:py-28 overflow-hidden bg-white">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-purple-100 rounded-full filter blur-3xl opacity-20 -translate-x-1/2 -translate-y-1/2"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-yellow-100 rounded-full filter blur-3xl opacity-20 translate-x-1/2 translate-y-1/2"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        {/* Header Section */}
        <div className="text-center mb-16">
          <span className="home-section-eyebrow mb-6 inline-block rounded-full bg-purple-50 px-4 py-2 text-purple-600">
            Trusted by Industry Leaders
          </span>
          <h2 className="home-section-title mb-6 text-gray-900">
            Powering Success Since 2020
          </h2>
          <p className="home-section-copy mx-auto max-w-3xl text-gray-600">
            Join the growing list of startups and enterprises who trust us to deliver innovative digital solutions
          </p>
        </div>

      <div className="mt-16">
        <Swiper
          loop={true}
          autoplay={{
            delay: 2000,
          }}
          breakpoints={{
            640: { slidesPerView: 1 },
            778: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1224: { slidesPerView: 4 },
            1324: { slidesPerView: 4 },
            1524: { slidesPerView: 4 },
          }}
          modules={[Autoplay]}
          className="mySwiper"
        >
          <SwiperSlide>
            <div className="group flex items-center justify-center p-8 bg-white rounded-2xl border border-gray-100 hover:border-purple-200 shadow-md hover:shadow-xl transition-all duration-500 mx-3 h-40 hover:-translate-y-1">
              <img src="/Images/cevious.png" alt="Cevious" className="object-contain max-h-24 w-full filter grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500" />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="group flex items-center justify-center p-8 bg-white rounded-2xl border border-gray-100 hover:border-purple-200 shadow-md hover:shadow-xl transition-all duration-500 mx-3 h-40 hover:-translate-y-1">
              <img src="/Images/lordkrishna.png" alt="Lord Krishna" className="object-contain max-h-24 w-full filter grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="group flex items-center justify-center p-8 bg-white rounded-2xl border border-gray-100 hover:border-purple-200 shadow-md hover:shadow-xl transition-all duration-500 mx-3 h-40 hover:-translate-y-1">
              <img src="/Images/glaa.png" alt="GLAA" className="object-contain max-h-24 w-full filter grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="group flex items-center justify-center p-8 bg-white rounded-2xl border border-gray-100 hover:border-purple-200 shadow-md hover:shadow-xl transition-all duration-500 mx-3 h-40 hover:-translate-y-1">
              <img src="/Images/trends.png" alt="Trends" className="object-contain max-h-24 w-full filter grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="group flex items-center justify-center p-8 bg-white rounded-2xl border border-gray-100 hover:border-purple-200 shadow-md hover:shadow-xl transition-all duration-500 mx-3 h-40 hover:-translate-y-1">
              <img src="/Images/effectual.png" alt="Effectual" className="object-contain max-h-24 w-full filter grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500" />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="group flex items-center justify-center p-8 bg-white rounded-2xl border border-gray-100 hover:border-purple-200 shadow-md hover:shadow-xl transition-all duration-500 mx-3 h-40 hover:-translate-y-1">
              <img src="/Images/odhini.png" alt="Odhini" className="object-contain max-h-24 w-full filter grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500" />
            </div>
          </SwiperSlide>

          {/* <SwiperSlide>ssCrabgrasss.png
            <DetailCart image={"/Images/ClientlogoOdhini.jpeg"} />
          </SwiperSlide>
          <SwiperSlide>
            <DetailCart image={"/Images/EffectualClientlogo.png"} />
          </SwiperSlide>
          <SwiperSlide>
            <DetailCart image={"/Images/clientlogoCevious.png"} />
          </SwiperSlide>
          <SwiperSlide>
            <DetailCart image={"/Images/bharatclient.png"} />
          </SwiperSlide>

          <SwiperSlide>
            <DetailCart image={"/Images/trands.png"} />
          </SwiperSlide>
          <SwiperSlide>
            <DetailCart image={"/Images/LORD.png"} />
          </SwiperSlide>
          <SwiperSlide>
            <DetailCart
              image={"/Images/NEWTALENT.png"}
              backgroundColor="BLACK"
            />
          </SwiperSlide>
          <SwiperSlide>
            <DetailCart
              image={"/Images/crabgrass.png"}
              backgroundColor="BLACK"
            />
          </SwiperSlide>
          <SwiperSlide>
            <DetailCart image={"/Images/l13.png"} backgroundColor="BLACK" />
          </SwiperSlide>
          <SwiperSlide>
            <DetailCart image={"/Images/l7.png"} backgroundColor="BLACK" />
          </SwiperSlide>
          <SwiperSlide>
            <DetailCart
              image={"/Images/PrathaLogo.png"}
              backgroundColor="BLACK"
            />
          </SwiperSlide>
          <SwiperSlide>
            <DetailCart
              image={"/Images/Swasthmainpuri.png"}
              backgroundColor="BLACK"
            />
          </SwiperSlide> */}
        </Swiper>
      </div>
      </div>
    </div>
  );
};

export default Client;
